export function coerceNullToUndefined<T>(x: T | null): T | undefined {
    if (x === null) {
        return undefined;
    }
    return x;
}
